import { ListFilter } from "lucide-react"
import styles from "./MobileFilterBar.module.css"
import { SearchBar } from "./SearchBar.js"
import { countActiveFilters } from "./filterConstants.js"
import type { Filters } from "./useBenefits.js"

interface Props {
  filters: Filters
  onChange: (partial: Partial<Filters>) => void
  onOpenDrawer: () => void
}

export function MobileFilterBar({ filters, onChange, onOpenDrawer }: Props) {
  const activeCount = countActiveFilters(filters)

  return (
    <div className={styles.bar}>
      <SearchBar value={filters.query} onChange={(query) => onChange({ query })} />
      <button type="button" className={styles.detailButton} onClick={onOpenDrawer}>
        <ListFilter className={styles.buttonIcon} size={18} aria-hidden />
        絞り込み
        {activeCount > 0 && <span className={styles.badge}>{activeCount}</span>}
      </button>
    </div>
  )
}
